import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './CollectionHistory.css';

const monthOptions = [
  { name: 'All', value: '' },
  { name: 'January', value: '1' },
  { name: 'February', value: '2' },
  { name: 'March', value: '3' },
  { name: 'April', value: '4' },
  { name: 'May', value: '5' },
  { name: 'June', value: '6' },
  { name: 'July', value: '7' },
  { name: 'August', value: '8' },
  { name: 'September', value: '9' },
  { name: 'October', value: '10' },
  { name: 'November', value: '11' },
  { name: 'December', value: '12' }
];

// ---- Date + Time Formatter ----
const formatDateTime = (input) => {
  if (!input) return '';
  const d = new Date(input);
  if (isNaN(d)) return input; // fallback if parsing fails

  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();

  let hh = d.getHours();
  const min = String(d.getMinutes()).padStart(2, '0');
  const ampm = hh >= 12 ? 'PM' : 'AM';
  hh = hh % 12;
  hh = hh ? hh : 12; // 0 => 12

  return `${dd}-${mm}-${yyyy} ${hh}:${min} ${ampm}`;
};

const CollectionHistory = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState('');

  const fetchData = async (month = '') => {
    setLoading(true);
    try {
      const res = await axios.get(
        `collection_history.php${month ? '?month=' + month : ''}`,
        { withCredentials: true }
      );
      setHistory(res.data || []);
    } catch {
      setHistory([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleMonthChange = (e) => {
    const month = e.target.value;
    setSelectedMonth(month);
    fetchData(month);
  };

  const calculateTotal = () => {
    return history.reduce((sum, h) => sum + parseFloat(h.amount || 0), 0).toFixed(2);
  };

  const handlePrint = () => {
  const printContents = document.getElementById('print-section').innerHTML;
  const monthLabel = selectedMonth
    ? '- ' + monthOptions.find(m => m.value === selectedMonth).name
    : '';
  const printWindow = window.open('', '', 'height=800,width=1100');
  printWindow.document.write(`
    <html>
      <head>
        <title>Collection History</title>
        <style>
          body { font-family: Arial, sans-serif; font-size: 13px; padding: 24px; }
          .print-box {
            border: 2px solid #222; padding: 32px 36px; margin: 28px auto 16px auto; width: 98%; background: #fff;
          }
          .school-logo {
            display: block;
            margin: 0 auto 10px auto;
            width: 70px;
            height: 70px;
            object-fit: contain;
          }
          .school-title {
            text-align: center;
            font-size: 22px;
            font-weight: bold;
            margin-bottom: 2px;
          }
          .school-address {
            text-align: center;
            font-size: 14px;
            color: #555;
            margin-bottom: 12px;
          }
          .print-heading {
            text-align: center;
            font-size: 18px;
            font-weight: 600;
            margin: 18px 0 16px 0;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 8px;
            margin-bottom: 14px;
          }
          th, td {
            border: 1px solid #000;
            padding: 8px;
            text-align: left;
          }
          th {
            background-color: #f2f2f2;
            font-weight: bold;
            text-align: center;
          }
          tr:last-child td {
            font-weight: bold;
            background: #ffe0b2;
          }
        </style>
      </head>
      <body>
        <div class="print-box">
          <img src="/school-logo.jpg" alt="School Logo" class="school-logo" onload="window.print(); window.close();" />
          <div class="school-title">OXFORD CONVENT ENGLISH MEDIUM SCHOOL, KHAJURI</div>
          <div class="school-address">Khajuri - 585314, Tq. Aland, Dist. Kalaburagi</div>
          <div class="print-heading">Collection History ${monthLabel}</div>
          ${printContents}
        </div>
      </body>
    </html>
  `);

  // Important: finish writing before the onload fires
  printWindow.document.close();
};


  return (
    <div className="collection-history-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <select value={selectedMonth} onChange={handleMonthChange} className="month-filter">
          {monthOptions.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.name}</option>
          ))}
        </select>
        <button className="print-btn" onClick={handlePrint}>Print</button>
      </div>

      <h2>Collection History</h2>

      {loading ? (
        <p>Loading...</p>
      ) : history.length === 0 ? (
        <p>No records found.</p>
      ) : (
        <div id="print-section">
          <table className="history-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Name</th>
                <th>Class</th>
                <th>Father</th>
                <th>Mother</th>
                <th>Amount</th>
                <th>Payment Type</th>
                <th>Mode</th>
                <th>Transaction ID</th>
                <th>Bill No.</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h, i) => (
                <tr key={i}>
                  <td>{formatDateTime(h.payment_date || h.created_at)}</td>
                  <td>{h.full_name}</td>
                  <td>{h.class_name}</td>
                  <td>{h.father_name}</td>
                  <td>{h.mother_name}</td>
                  <td>{h.amount}</td>
                  <td>{h.payment_type}</td>
                  <td>{h.transaction_mode}</td>
                  <td>{h.transaction_id}</td>
                  <td>{h.bill_number}</td>
                </tr>
              ))}
              <tr>
                <td colSpan="5"><strong>Total</strong></td>
                <td colSpan="5"><strong>₹ {calculateTotal()}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CollectionHistory;
